import { gql } from '@apollo/client';

export const GET_TINYKEY = gql`
  query getTinyKey {
    getTinyKey
  }
`;
